module.exports = __webpack_public_path__ + "media/components/country-flag/static/gb-wls-6c4e02daab2ce5a155c925a1217c329e.svg";